import React, { useEffect, useState } from "react";
import "./Toaster.css";

export default function Toaster({
  show = false,
  message = "",
  type = "success",
  duration = 3,
  onClose,
}) {
  const [shouldRender, setShouldRender] = useState(show);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (show) {
      setShouldRender(true);
      setIsExiting(false);
    } else if (shouldRender) {
      setIsExiting(true);
      const exitTimer = setTimeout(() => setShouldRender(false), 320);
      return () => clearTimeout(exitTimer);
    }
  }, [show, shouldRender]);

  useEffect(() => {
    if (!show) return;
    const timeoutMs = Math.max(Number(duration) || 0, 1) * 1000;
    const autoCloseTimer = setTimeout(() => {
      if (typeof onClose === "function") onClose();
    }, timeoutMs);
    return () => clearTimeout(autoCloseTimer);
  }, [show, duration, onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className={[
        "app-toaster",
        `app-toaster--${type}`,
        isExiting ? "app-toaster--exit" : "app-toaster--enter",
      ].join(" ")}
      role="status"
      aria-live="polite"
    >
      <span className="app-toaster__message">{message}</span>
      <button
        type="button"
        className="app-toaster__close"
        onClick={() => {
          if (typeof onClose === "function") onClose();
        }}
      >
        ×
      </button>
    </div>
  );
}

